import React from "react";
import { Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { FormattedMessage, useIntl, defineMessages } from "react-intl";
import dayjs from "dayjs";

import useNodeChannelConfig from "../../../hooks/useNodeChannelConfig";
import { errorNotification } from "../../../lib/utils/notification";
import exportConfigToFile from "../../../lib/utils/exportConfigToFile";
import { FORM_VERSION_V5 } from "../../../lib/utils/constants";

const translations = defineMessages({
  noConfigToExport: {
    id: "ExportConfigButton.noConfigToExport",
    defaultMessage: "Export error - Invalid or missing configuration",
  },
  exportError: {
    id: "ExportConfigButton.exportError",
    defaultMessage: "An error occurred while exporting configuration",
  },
});

export default function ExportConfigButton() {
  const { channelConfig } = useNodeChannelConfig();
  const { formatMessage } = useIntl();

  const handleExportConfig = () => {
    try {
      if (!channelConfig) {
        errorNotification(formatMessage)(translations.noConfigToExport);

        return;
      }

      const exportData = {
        exportDate: dayjs().toISOString(),
        version: FORM_VERSION_V5,
        channelConfig,
      };

      const jsonString = JSON.stringify(exportData, null, 2);

      const formattedDate = dayjs().format("YYYY-MM-DD_HH-mm-ss");
      const filename = `${channelConfig.name}-config-${formattedDate}.json`;

      exportConfigToFile(jsonString, filename, "application/json");
    } catch (error) {
      errorNotification(formatMessage)(translations.exportError);
    }
  };

  return (
    <Button icon={<DownloadOutlined />} type="dashed" onClick={handleExportConfig}>
      <span>
        <FormattedMessage id="ExportConfigButton.exportConfig" defaultMessage="Export Config" />
      </span>
    </Button>
  );
}
